"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectionPanel_1 = require("./SelectionPanel");
exports.default = SelectionPanel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectionPanel/index.js
// module id = 1408
// module chunks = 8